import Cw8Create from "components/cw8/Cw8Create";
import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";

export const BibliotecaVirtualCreate: React.FC<IResourceComponentsProps> = () => {
    const resourceName = "bibliotecaVirtual"
    return (
        <Cw8Create resourceName={resourceName} />
    );
};
